import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import services from 'core/services';
import { PureComponent } from 'core/components';
import { Row, Col } from 'core/components/Framework7';
import { CategoryItem } from 'content/components';

import classes from './styles.module.css';
import { withAuth } from '../../../core/decorators';

class CategoryList extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {

    };
  }

  get initialValue() {
    return this.parseCategoryItems()
  }

  /**
   * parse items for show in category
   * @param {Array} items 
   */
  parseCategoryItems() {
    const { items } = this.props;

    return items.map(item => {
      return this.parseCategoryItem(item)
    })
  }

  /**
   * parse item of category
   * @param {Object} item 
   */
  parseCategoryItem(item) {
    return {
      id: item.id,
      alt: item.category ? item.category.cover ? item.category.cover.title : null : null,
      url: item.category ? item.category.cover ? services.utils.url.image(item.category.cover, 6) : null : null,
      title: item.category ? item.category.title : null,
      link: item.id,
      childrenType: item.childrenType,
    }
  }

  rendeList() {
    const items = this.initialValue

    return items.map(item => {
      return this.renderItem(item)
    })
  }

  renderItem(item) {
    const { navigate } = this.props;

    return (
      <div
        key={item.id}
        className={`${classes.categoryItem} col-auto`}
        // Just use style for fast rendering
        style={{ '--f7-cols-per-row': 'var(--list-cols-per-row)' }}
      >
        <CategoryItem
          item={item}
          navigate={navigate}
        />
      </div>
    )
  }

  render() {
    return (
      <Row className={`${classes.container} page-bottom-padding`}>
        {this.rendeList()}
      </Row>
    )
  }
}

CategoryList.propTypes = {
  items: PropTypes.array,
};

export default connect(
  state => ({
    env: state.General.env,
  }),
  {
  }
)(withAuth(autobind(CategoryList)));
